exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip[data-v-c2a6c200]{white-space:pre-line}", ""]);

// exports
